import usePersistedState from 'hooks/usePersistedState'
import { Modal, useModalControls } from '../Modal'
import { useEffect } from 'react'
import { useModule } from 'context'

export const CriteriaUpdateModal = () => {
  const { name: moduleName } = useModule()
  const currentModalVersion = 1 // Cache buster for when we update this modal content.

  const [viewedUpdateModal, setViewedUpdateModal] = usePersistedState('updateModal', { version: undefined }, localStorage, false)
  const updateModalControls = useModalControls()

  useEffect(() => {
    if (viewedUpdateModal.version !== currentModalVersion) {
      updateModalControls.open()
    }
  }, [viewedUpdateModal, updateModalControls])

  const markUpdateModalViewed = () => {
    setViewedUpdateModal({ version: currentModalVersion })
  }

  if (!moduleName || moduleName !== 'EHCP') return null

  return (
    <Modal title="We've made some improvements to your audit experience" size='mini' closeText='I understand' controls={updateModalControls} afterClose={markUpdateModalViewed}>
      <div className='update-modal-content'>
        <p>
          You might notice some changes to your in-progress or completed audits. We’ve updated parts of the audit criteria and refined the grading methodology based on feedback
          from our early adopter LAs.
        </p>
        <p>
          To apply the updated grading, simply reopen your audit and re-run the grading. You’ll also see a few new questions added to <b>Section E</b>.
        </p>
        <p>If you have any questions, please speak to your LA coordinator.</p>
      </div>
    </Modal>
  )
}
